export default "__VITE_ASSET__DzcIcVdx__"